import Vue from 'vue';

const state = () => ({
	informations: {}
});

const getters = {
	getUserInformations: state => {
		return state.informations;
	}
};

const mutations = {
	setUserInformations (state, informations) {
		Vue.set(state, 'informations', informations);
	}
};

const actions = {};

export default {
	state,
	getters,
	actions,
	mutations
};
